<template>
  <base-filter-expander
    class="description"
    :title="$t('details.more-details')"
    :with-validation="false"
  >
    <div class="description__trim">
      {{ trim }}
    </div>
    <ul class="description__list">
      <li v-for="option in options" :key="option" class="description__option">
        <checkmark-image class="description__checkmark" />
        {{ option }}
      </li>
    </ul>
    <div v-if="!options.length" class="description__empty">
      <p v-if="description">{{ description }}</p>
      <p v-else>{{ $t("details.no-more-details") }}</p>
    </div>
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import CheckmarkImage from "@/assets/images/checkmark.svg";

export default {
  name: "DetailsCarDescription",
  components: {
    BaseFilterExpander,
    CheckmarkImage
  },
  props: {
    trim: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
.description {
  line-height: 22px;

  &__option {
    margin: 10px 0;
  }

  &__checkmark {
    margin-right: 19px;
  }
}

@media screen and (min-width: $media-l) {
  .description__trim {
    display: none;
  }

  .description__list {
    @include grid-columns(3);
    @include grid-ie11-fix(3);
  }

  .description__option {
    margin: 5px 0;
  }

  .description__empty {
    padding: 0 20px;
  }
}

@media screen and (min-width: $media-xxl) {
  .description__list {
    @include grid-columns(4);
    @include grid-ie11-fix(4);

    padding: 0 30px;
  }
}
</style>
